import { createSelector } from 'reselect';

import {
    RECOMMENDED,
    FASTEST,
    CHEAPEST,
    EARLIEST,
    LATEST,
} from '../../filterData/constants';
import { selectFilteredTrips } from './trips';

function _countTrips(trips) {
    if (!trips) {
        return;
    }

    return trips.length;
}

function _getCheapestPrice(trips) {
    if (!trips || trips.length === 0) {
        return;
    }

    const minTrip = trips.reduce((minTrip, trip) => {
        if (minTrip._priceInUSDForSorting > trip._priceInUSDForSorting) {
            return trip;
        }

        return minTrip;
    }, trips[0]);

    return minTrip.pricing;
}

function _getFastestDuration(trips) {
    if (!trips || trips.length === 0) {
        return;
    }

    return Math.min(...trips.map((trip) => trip.duration));
}

function _getEarliestDepartTime(trips) {
    if (!trips || trips.length === 0) {
        return;
    }

    const earliestTrip = trips.reduce((earliestTrip, trip) => {
        if (earliestTrip.departDateTimeUTC > trip.departDateTimeUTC) {
            return trip;
        }

        return earliestTrip;
    }, trips[0]);

    return earliestTrip.localizedDepartDateTime;
}

function _getLatestDepartTime(trips) {
    if (!trips || trips.length === 0) {
        return;
    }

    const latestTrip = trips.reduce((latestTrip, trip) => {
        if (latestTrip.departDateTimeUTC < trip.departDateTimeUTC) {
            return trip;
        }

        return latestTrip;
    }, trips[0]);

    return latestTrip.localizedDepartDateTime;
}

const selectTripCount = createSelector(
    selectFilteredTrips,
    _countTrips,
);

const selectCheapestPrice = createSelector(
    selectFilteredTrips,
    _getCheapestPrice,
);

const selectFastestDuration = createSelector(
    selectFilteredTrips,
    _getFastestDuration,
);

const selectEarliestDepartTime = createSelector(
    selectFilteredTrips,
    _getEarliestDepartTime,
);

const selectLatestDepartTime = createSelector(
    selectFilteredTrips,
    _getLatestDepartTime,
);

const selectSortOptions = createSelector(
    selectTripCount,
    selectCheapestPrice,
    selectFastestDuration,
    selectEarliestDepartTime,
    selectLatestDepartTime,
    (...args) => ({
        [RECOMMENDED]: args[0],
        [CHEAPEST]: args[1],
        [FASTEST]: args[2],
        [EARLIEST]: args[3],
        [LATEST]: args[4],
    }),
);

export {
    selectSortOptions,
};
